import { render, staticRenderFns } from "./OfferNew.vue?vue&type=template&id=48d838f6&"
import script from "./OfferNew.vue?vue&type=script&lang=js&"
export * from "./OfferNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports